import React from 'react'
import { Button, Select, Skeleton } from '@/shared/ui'
import { listFinanceCustomersRisk, type FinanceCustomerRiskRow } from '../services/financeReportsService'
import { FinanceCustomersRiskTable } from './FinanceCustomersRiskTable'

type Props = {
  refreshKey: number
}

export function FinanceCustomersTab({ refreshKey }: Props) {
  const [days, setDays] = React.useState(15)
  const [rows, setRows] = React.useState<FinanceCustomerRiskRow[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      const data = await listFinanceCustomersRisk(days)
      setRows(data)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar clientes em risco')
      setRows([])
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { load() }, [days, refreshKey])

  return (
    <div className="space-y-3">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground/70">Janela</span>
          <Select value={String(days)} onChange={(e) => setDays(Number((e.target as HTMLSelectElement).value) || 15)}>
            <option value="7">7 dias</option>
            <option value="15">15 dias</option>
            <option value="30">30 dias</option>
            <option value="60">60 dias</option>
          </Select>
          <span className="text-sm text-foreground/70">para “expira em breve”</span>
        </div>
        <Button onClick={() => load()} disabled={loading}>Atualizar</Button>
      </div>

      {error && <div className="text-sm text-red-400">{error}</div>}

      <div className="rounded-2xl border border-slate-800/80 bg-slate-950/80 p-4">
        {loading && !rows.length ? <Skeleton className="h-40 w-full" /> : <FinanceCustomersRiskTable rows={rows} />}
      </div>
    </div>
  )
}

